import { createFeatureSelector, createSelector } from '@ngrx/store';
import {
  CHAPTER_PROGRESS_FEATURE_KEY,
  ChapterProgressState,
  chapterProgressAdapter,
} from './chapter-progress.reducer';

export const selectChapterProgressState =
  createFeatureSelector<ChapterProgressState>(CHAPTER_PROGRESS_FEATURE_KEY);

const { selectAll } = chapterProgressAdapter.getSelectors();

export const selectAllChapterProgresses = createSelector(
  selectChapterProgressState,
  (state: ChapterProgressState) => selectAll(state),
);
